import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { PDFDownloadLink } from "@react-pdf/renderer";

import DashboardHeader from "../dashboardHeader";
import DashBoardContainer from "../../../components/containers/dashboardContainer";
import ReviewCard from "../../../components/reviewCard";
import {
  fetchFirmApplicationStatus as fetchFirmApplication,
  updateFirmApplication,
  fetchFile,
} from "../../../actions";
import ier_logo from "../../../assets/images/icons/ier-logo2.png";
import moment from "moment";
import PdfReport from "../../../components/downloadPdf/pdfReport";
import { SUBMIT_FIRM_APPLICATION_ID } from "../../../store/loaders";
import close_icon from "../../../assets/images/icons/close.png";

const FirmApplicationDetails = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const apiResponse = useSelector((state) => {
    const {
      firmApplication,
      fetchFile,
      firmApplicationSubmitted,
      updatedFirmApplication,
      hasUpdatedFirm,
      loader,
    } = state;
    const { application } = firmApplication;
    const { file } = fetchFile;
    const { response } = firmApplicationSubmitted;
    const { status } = updatedFirmApplication;
    const { updateId } = hasUpdatedFirm;
    const { isLoading } = loader[SUBMIT_FIRM_APPLICATION_ID] || {
      isLoading: false,
    };

    return {
      application,
      file,
      response,
      status,
      updateId,
      isLoading,
    };
  });

  const [applicationDetails, setApplicationDetails] = useState({});
  const [requiredFields, setRequiredFields] = useState([]);

  const [hasDownloaded, setHasDownloaded] = useState(false);
  const [download, setDownload] = useState(false);

  var applicationId =
    apiResponse.application?.id || apiResponse.application?.applicationId;
  var actionLoader = apiResponse.isLoading;
  const appId = props.location.state && props.location.state.application?.id;
  const message = props.location?.state?.message;

  const [requestId, setRequestId] = useState("");

  useEffect(() => {
    dispatch(fetchFirmApplication(appId));
  }, []);

  useEffect(() => {
    if (apiResponse.response?.status === "success") {
      dispatch(fetchFirmApplication(appId));
    }
    if (
      apiResponse.updateId === requestId &&
      apiResponse.response?.status === "success"
    ) {
      if(applicationDetails?.status?.toLowerCase().includes("payment")){
        history.push({
          pathname: "/applicant/payment-details",
          state: {
            application: applicationDetails,
            isFirm: false,
          },
        });
      }else{
        history.push('/dashboard')
      }
    }
  }, [apiResponse.response, apiResponse.updateId]);

  useEffect(() => {
    if (apiResponse.file?.fileText != null && !hasDownloaded && download) {
      var a = document.createElement("a");
      a.href =
        "data:image/" +
        apiResponse.file?.type +
        ";base64," +
        apiResponse.file?.fileText;
      a.download =
        apiResponse.file?.name || "File" + "." + apiResponse.file?.type || "";
      a.click();
      setHasDownloaded(true);
    }
  }, [apiResponse.file]);

  useEffect(() => {
    if (apiResponse.application?.id) {
      setApplicationDetails({
        ...apiResponse.application,
      });
    }
  }, [apiResponse.application]);

  const handleSaveForLater = () => {
    history.push("/dashboard");
  };

  const handleSubmit = () => {
    const reqId = uuidv4();
    setRequestId(reqId);
    let applicationStatus = 'submitted'
    if(applicationDetails?.status?.toLowerCase().includes('rejected')){
        applicationStatus = 'Pending for review'
    }
    const sentData = {
      ...applicationDetails,
      step: 7,
      status: applicationStatus,
    };
    if (
      applicationDetails.discipline?.id === "" ||
      applicationDetails.discipline === null
    ) {
      requiredFields.push("Discipline");
    }
    if (applicationDetails.portraitPhotoFile === null) {
      requiredFields.push("Portrait photo");
    }
    if (applicationDetails.companyNames === null) {
      requiredFields.push("Company names");
    }
    if (applicationDetails.companyActivities === null) {
      requiredFields.push("Company activities");
    }
    if (applicationDetails.registrationDate === null) {
      requiredFields.push("Registration date");
    }
    if (applicationDetails.businessCertificateNumber === null) {
      requiredFields.push("Business certificate number");
    }
    if (applicationDetails.contactTelephoneNumber === null) {
      requiredFields.push("Phone number");
    }
    if (applicationDetails.contactEmail === null) {
      requiredFields.push("Email");
    }
    if (applicationDetails.secondaryContactTelephoneNumber === null) {
      requiredFields.push("Next of kin phone number");
    }
    if (applicationDetails.secondaryContactEmail === null) {
      requiredFields.push("Next of kin email");
    }
    if (applicationDetails.residenceType === "Local") {
      if (
        applicationDetails.provinceId === "" ||
        applicationDetails.provinceId === null
      ) {
        requiredFields.push("Province");
      }
      if (
        applicationDetails.districtId === "" ||
        applicationDetails.districtId === null
      ) {
        requiredFields.push("District");
      }
      if (
        applicationDetails.sectorId === "" ||
        applicationDetails.sectorId === null
      ) {
        requiredFields.push("Sector");
      }
      if (
        applicationDetails.villageId === "" ||
        applicationDetails.villageId === null
      ) {
        requiredFields.push("Village");
      }
    }
    if (applicationDetails.residenceType === "Foreigner") {
      if (
        applicationDetails.countryOfResidence === "" ||
        applicationDetails.countryOfResidence === null
      ) {
        requiredFields.push("Country of residence");
      }
      if (
        applicationDetails.residenceAddress === "" ||
        applicationDetails.residenceAddress === null
      ) {
        requiredFields.push("Residence address");
      }
    }
    if (applicationDetails.stakeholders.length <= 0) {
      requiredFields.push("Company shareholders");
    }
    if (applicationDetails.projects.length <= 0) {
      requiredFields.push("Company projects");
    }
    if (applicationDetails.cv === null) {
      requiredFields.push(`Managing or technical director's resume`);
    }
    if (applicationDetails.businessCertificateDocumentFile === null) {
      requiredFields.push("Business certificate file");
    }
    if (applicationDetails.practicingLicenseDocumentFile === null) {
      requiredFields.push(
        "Managing/Technical Director’s Practicing Licensen file"
      );
    }
    if (applicationDetails.companyProfileDocumentFile === null) {
      requiredFields.push("Company Profile file");
    }
    if (applicationDetails.rssbCertificateDocumentFile === null) {
      requiredFields.push("RSSB Certificate file");
    }
    if (applicationDetails.taxClearanceDocumentFile === null) {
      requiredFields.push("RRA Tax Clearance Certificate file");
    }
    if (applicationId && requiredFields.length <= 0) {
      dispatch(
        updateFirmApplication({
          data: {
            ...sentData,
          },
          id: applicationId,
          reqId: reqId,
        })
      );
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleFileDownload = (value) => {
    let url;
    if (value) {
      url = encodeURIComponent(
        value.substring(value.indexOf("/tmp"), value.length)
      );
      dispatch(fetchFile(url));
    }
    setDownload(true);
    setHasDownloaded(false);
  };

  const handleCancel = () => {
    history.push({
      pathname: "/applicant/company/attachments",
      state: {
        application: applicationDetails,
      },
    });
  };
  return (
    <div style={{ width: "100%" }}>
      <DashboardHeader activeStep={7} application={applicationDetails} />
      <DashBoardContainer
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        title="Submit"
        borderLess={true}
        handleSaveForLater={handleSaveForLater}
        middleTitle="Save for Later"
        loader={actionLoader}
        disabled={actionLoader}
      >
        {requiredFields.length > 0 && (
          <div className="require-fields-container">
            <div className="d-flex">
              <div className="img-container">
                <img src={close_icon} onClick={() => setRequiredFields([])} />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {requiredFields.map((el) => {
                  return <li>{el} is required</li>;
                })}
              </div>
            </div>
          </div>
        )}
        <div className="d-flex mb-2">
          <span
            className="dashboard-green-text-header"
            style={{ margin: "auto" }}
          >
            Review application details
          </span>
        </div>
        <div className="dashboard-review-container">
          <div className="dashboard-review-title-container">
            <div
              style={{
                width: "10%",
              }}
            >
              <img src={ier_logo} />
            </div>
            <div
              style={{
                width: "70%",
              }}
            >
              <span className="review-header-title-text">
                INSTITUTION OF ENGINEERS RWANDA
              </span>
              <br />
              <span className="review-sub-title">
                Kimihurura - KG 666st Kigali-Rwanda <br />
                P.o.Box 4386 Kigali Rwanda <br />
                Telephone:
                <span
                  style={{
                    fontWeight: "bold",
                    marginLeft: 2,
                  }}
                >
                  (+250) 789 904 228
                </span>
                - Email:
                <span
                  style={{
                    fontWeight: "bold",
                    marginLeft: 2,
                  }}
                >
                  info@engineersrwanda.rw
                </span>
                - website:
                <span
                  style={{
                    fontWeight: "bold",
                    marginLeft: 2,
                  }}
                >
                  https://www.engineersrwanda.rw
                </span>
              </span>
            </div>
            {message?.status?.toLowerCase().includes('rejected') ? (
              <div
                style={{
                  width: "50%",
                  border: "1px solid red",
                  padding: "30px 20px",
                  display: "flex",
                  flexDirection: "column",
                }}>
                <span>Status: {message?.status}</span>
                <div>
                  <span>Message: </span>
                  <span
                    style={{
                      color: "red",
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    {applicationDetails?.latestComment || '-'}
                  </span>
                </div>
                <span> Date: {message?.date}</span>
              </div>
            ) : <div style={{width: '50%'}}></div>
        }
          </div>
          <div>
            <ReviewCard
              title="Company details"
              path="/applicant/company/details"
              state={applicationDetails}
            >
              <div
                className="review-details-content-conatiner"
                style={{ justifyContent: "space-between" }}
              >
                <div className="review-details-profile-icon">
                  {applicationDetails.portraitPhotoFile && (
                    <img
                      src={`data:image/${applicationDetails.portraitPhotoFile?.type};base64,${applicationDetails.portraitPhotoFile?.fileText}`}
                      style={{ width: "100%", height: "80%" }}
                    />
                  )}
                </div>
                <div className="review-details-profile-container">
                  <div>
                    <div>
                      <span>Company names</span>
                      <p>{applicationDetails.companyNames}</p>
                    </div>
                    <div>
                      <span>Company activities</span>
                      <p>{applicationDetails.companyActivities}</p>
                    </div>
                  </div>
                </div>

                <div className="review-details-gender-details">
                  <div>
                    <span>Date of business registration</span>
                    <p>
                      {moment(applicationDetails.registrationDate).format(
                        "MMMM Do YYYY, h:mm:ss a"
                      )}
                    </p>
                  </div>
                  <div>
                    <span>Business Certificate number</span>
                    <p>{applicationDetails.businessCertificateNumber}</p>
                  </div>
                </div>
              </div>
            </ReviewCard>

            <ReviewCard
              title="Contact details"
              path="/applicant/company/contacts"
              state={applicationDetails}
            >
              <div className="review-details-content-conatiner">
                <div className="review-details-contact-container-first">
                  <div className="d-flex">
                    <div className="contancts-container">
                      <div>
                        <span>Phone number</span>
                        <p>{applicationDetails.contactTelephoneNumber}</p>
                      </div>
                    </div>
                    <div className="">
                      <div>
                        <span>Email address</span>
                        <p>{applicationDetails.contactEmail}</p>
                      </div>
                    </div>
                  </div>
                  <div className="seperator-contact"></div>
                  <div className="d-flex">
                    <div className="contancts-container">
                      <div>
                        <span>Secondary Phone number</span>
                        <p>
                          {applicationDetails.secondaryContactTelephoneNumber}
                        </p>
                      </div>
                    </div>
                    <div className="">
                      <div>
                        <span>Main Email address</span>
                        <p>{applicationDetails.secondaryContactEmail}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="review-details-contact-container-second">
                  <div className="">
                    <div>
                      <span>Residence Address</span>
                      {applicationDetails.residenceType === "Local" ? (
                        <p>
                          {applicationDetails.provinceId?.name},
                          {applicationDetails.districtId?.name},
                          {applicationDetails.sectorId?.name},
                          {applicationDetails.cellId?.name},
                          {applicationDetails.villageId?.name},
                          {applicationDetails.streetOrHouseNumber}
                        </p>
                      ) : (
                        <p>
                          {applicationDetails.countryOfResidence?.name},{" "}
                          {applicationDetails.residenceAddress}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </ReviewCard>

            <ReviewCard
              title="Company Directors/ Shareholders"
              path="/applicant/company/shareholders"
              state={applicationDetails}
            >
              <div className="review-details-content-conatiner">
                <div
                  className="review-details-contact-container-first"
                  style={{ width: "100%" }}
                >
                  {applicationDetails.stakeholders?.length > 0 &&
                    applicationDetails.stakeholders?.map((value) => {
                      return (
                        <>
                          <div
                            className="d-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div>
                              <div>
                                <span>Full names</span>
                                <p>{value.fullName}</p>
                              </div>
                            </div>
                            <div className="">
                              <div>
                                <span>Phone</span>
                                <p>{value.telephoneNumber}</p>
                              </div>
                            </div>
                            <div>
                              <span>National ID number</span>
                              <p>{value.nationalIdNumber}</p>
                            </div>
                            <div>
                              <span>IER number</span>
                              <p>{value.ierMemberNumber}</p>
                            </div>
                          </div>
                          <div
                            className="seperator-contact"
                            style={{ width: "100%" }}
                          ></div>
                        </>
                      );
                    })}
                </div>
              </div>
            </ReviewCard>
            <ReviewCard
              title="Projects accomplished details"
              path="/applicant/company/projects"
              state={applicationDetails}
            >
              <div className="review-details-content-conatiner">
                <div
                  className="review-details-contact-container-first"
                  style={{ width: "100%" }}
                >
                  {applicationDetails.projects?.length > 0 &&
                    applicationDetails.projects.map((value) => {
                      return (
                        <>
                          <div
                            className="d-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div>
                              <div>
                                <span>Name of the project</span>
                                <p>{value.name}</p>
                              </div>
                            </div>
                            <div className="">
                              <div>
                                <span>Client</span>
                                <p>{value.client}</p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seperator-contact"
                            style={{ width: "100%" }}
                          ></div>
                        </>
                      );
                    })}
                </div>
              </div>
            </ReviewCard>

            <ReviewCard
              title="Attachments"
              path="/applicant/company/attachments"
              state={applicationDetails}
            >
              <div className="review-details-content-conatiner">
                <div
                  className="review-details-contact-container-first"
                  style={{ width: "100%" }}
                >
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    {applicationDetails.cv && (
                      <div>
                        <span> Managing or technical director's resume</span>
                        {/* <img src={`data:image/${applicationDetails.cv?.type};base64,${applicationDetails.cv?.fileText}`} style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {applicationDetails.cv?.name}
                        </p>
                        <span
                          onClick={() =>
                            handleFileDownload(applicationDetails.cv?.fileText)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          download
                        </span>
                      </div>
                    )}

                    {applicationDetails.businessCertificateDocumentFile && (
                      <div>
                        <span> certified Business certificate</span>
                        {/* <img src={`data:image/${applicationDetails.businessCertificateDocumentFile?.type};base64,${applicationDetails.businessCertificateDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {
                            applicationDetails.businessCertificateDocumentFile
                              ?.name
                          }
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.businessCertificateDocumentFile
                                ?.fileText
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}

                    {/* { applicationDetails.rdbRegistrationDocumentFile &&  <div>
                                                <span> RDB Registration Certificate</span>
                                                <p style={{marginBottom: '0px'}}>{applicationDetails.rdbRegistrationDocumentFile?.name}</p>
                                                <span 
                                                    onClick={()=>handleFileDownload(applicationDetails.rdbRegistrationDocumentFile?.fileText)}
                                                    style={{cursor: 'pointer'}}>download</span>
                                            </div> 
                                        } */}
                  </div>
                  <div
                    className="seperator-contact"
                    style={{ width: "100%" }}
                  ></div>
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    {applicationDetails.practicingLicenseDocumentFile && (
                      <div>
                        <span>
                          {" "}
                          Managing/Technical Director’s Practicing License
                        </span>
                        {/* <img src={`data:image/${applicationDetails.practicingLicenseDocumentFile?.type};base64,${applicationDetails.practicingLicenseDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {
                            applicationDetails.practicingLicenseDocumentFile
                              ?.name
                          }
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.practicingLicenseDocumentFile
                                ?.fileText
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}

                    {applicationDetails.companyProfileDocumentFile && (
                      <div>
                        <span> Company Profile</span>
                        {/* <img src={`data:image/${applicationDetails.companyProfileDocumentFile?.type};base64,${applicationDetails.companyProfileDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {applicationDetails.companyProfileDocumentFile?.name}
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.companyProfileDocumentFile
                                ?.fileText
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}

                    {applicationDetails.rssbCertificateDocumentFile && (
                      <div>
                        <span> RSSB Certificate</span>
                        {/* <img src={`data:image/${applicationDetails.rssbCertificateDocumentFile?.type};base64,${applicationDetails.rssbCertificateDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {applicationDetails.rssbCertificateDocumentFile?.name}
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.rssbCertificateDocumentFile
                                ?.fileText
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}
                  </div>
                  <div
                    className="seperator-contact"
                    style={{ width: "100%" }}
                  ></div>
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    {applicationDetails.taxClearanceDocumentFile && (
                      <div>
                        <span> RRA Tax Clearance Certificate</span>
                        {/* <img src={`data:image/${applicationDetails.taxClearanceDocumentFile?.type};base64,${applicationDetails.taxClearanceDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {applicationDetails.taxClearanceDocumentFile?.name}
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.taxClearanceDocumentFile
                                ?.fileText
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ReviewCard>
          </div>
        </div>
      </DashBoardContainer>
      <div
        style={{
          marginBottom: 20,
          marginTop: 20,
        }}
      >
        <PDFDownloadLink
          document={<PdfReport data={applicationDetails} />}
          fileName="report.pdf"
          style={{
            backgroundColor: "#0E348A",
            padding: "15px 20px",
            marginLeft: 80,
            textDecoration: "none",
            color: "white",
          }}
        >
          {({ blob, url, loading, error }) =>
            loading ? "Loading document..." : "DownLoad PDF Report"
          }
        </PDFDownloadLink>
      </div>
      {/* <PdfReport
                data={applicationDetails}/> */}
    </div>
  );
};

export default FirmApplicationDetails;
